import { Dialog, DialogContent } from "@/components/ui/dialog";
import { createCheckoutSessionState } from "@/store/checkoutSessionState";
import type { FC } from "react";
import { CheckoutProvider } from "@stripe/react-stripe-js/checkout";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "@/components/CheckoutForm";
import useDetectSizeDevice from "@/hooks/useDetectSizeDevice";
import { Drawer, DrawerContent } from "@/components/ui/drawer";

type Props = {
  openCheckout: boolean;
  onClose: () => void;
};

const Checkout: FC<Props> = ({ openCheckout, onClose }) => {
  const { data, isLoading } = createCheckoutSessionState();
  const { sm } = useDetectSizeDevice();

  if (sm) {
    return (
      <Dialog open={openCheckout}>
        <DialogContent
          showCloseButton={false}
          className="max-w-[1000px] sm:max-w-[1000px] max-h-full overflow-y-auto"
        >
          {isLoading && (
            <div className="w-[100%] h-[300px] flex items-center justify-center gap-[12px]">
              <img src="/svg/krunsh-icon.svg" style={{ zIndex: 2 }} />
              <img
                style={{
                  animation: "loading-layout 1.3s",
                }}
                src="/svg/krunsh.svg"
              />
            </div>
          )}
          {data && (
            <CheckoutProvider
              stripe={loadStripe(import.meta.env.VITE_STRIPE_PK)}
              options={{
                clientSecret: data.clientSecret,
                elementsOptions: {
                  appearance: { theme: "flat" },
                },
              }}
            >
              <CheckoutForm onClose={onClose} />
            </CheckoutProvider>
          )}
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={openCheckout}>
      <DrawerContent>
        {isLoading && (
          <div className="w-[100%] h-[300px] flex items-center justify-center gap-[12px]">
            <img src="/svg/krunsh-icon.svg" style={{ zIndex: 2 }} />
            <img
              style={{
                animation: "loading-layout 1.3s",
              }}
              src="/svg/krunsh.svg"
            />
          </div>
        )}
        {data && (
          <div className="p-[16px] overflow-y-auto">
            <CheckoutProvider
              stripe={loadStripe(import.meta.env.VITE_STRIPE_PK)}
              options={{
                clientSecret: data.clientSecret,
                elementsOptions: {
                  appearance: { theme: "flat" },
                },
              }}
            >
              <CheckoutForm onClose={onClose} />
            </CheckoutProvider>
          </div>
        )}
      </DrawerContent>
    </Drawer>
  );
};

export default Checkout;
